import React, { useEffect, useRef, useState } from "react";
import styles from "./ProductItem.module.scss";
import ProductItemTile from "../ProductItemTile";
import Popular from "../ProductMostPopular";
import Srcset from "@/components/common/Srcset";
import { Swiper, SwiperSlide } from "swiper/react";
import { A11y, Navigation } from "swiper";
import Link from "next/link";
import { buildLink, generateSlug, getSlug } from "@/helpers/slugHelper";
import { generalConstants } from "@/utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { isMenuVisible, setSearchIcon } from "@/redux/actions/headerAction";
import { showPwaLoader } from "@/redux/actions/pwaAction";

//Code changes for populer search
const ProductItem = ({
  autocomplete,
  autocompleteState,
  handleSearchClick,
  searchActive,
}) => {
  const [querys, setQuerys] = useState("");
  const [swiper, setSwiper] = useState();
  const prevRef = useRef();
  const nextRef = useRef();
  const dispatch = useDispatch();
  const isPWA = useSelector((state) => state.pwa.is_PWA);

  useEffect(() => {
    if (swiper) {
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }, [swiper]);

  useEffect(() => {
    if (searchActive) {
      inputRef.current.focus();
    }
  }, [searchActive]);

  const arr = [];
  const suggetionQuerys = []
 
  let uniqueChars = [];
  const shopifySuggetions = [];
  let categoryArr = [];
  const inputRef = React.useRef(null);
  const handleClickSearchClose = () => {
    autocomplete.setQuery("");
    autocomplete.setIsOpen(false);
    inputRef.current.value = ``;
    if (handleSearchClick) {
      if (isPWA) {
        dispatch(setSearchIcon(false))
        dispatch(isMenuVisible(false))
      } else {
        handleSearchClick();
      }
    }
  };

  useEffect(() => {
    let input = inputRef.current;
    return () => {
      autocomplete.setQuery("");
      autocomplete.setIsOpen(false);
      input.value = ``;
    };
  }, [searchActive, autocomplete]);

  const handleClearInput = () => {
    autocomplete.setQuery("");
    autocomplete.setIsOpen(false);
    inputRef.current.focus();
    inputRef.current.value = ``;
  };

  const redirectSearch = async (query, links, url) => {
    if(isPWA) {
      dispatch(showPwaLoader(true))
    }

    //SUP-3875 Gift card quick link is manually handled here to redirect on gift card PDP, because teh gift card product is tagged with categories.lvl1 due to which it is getting link as subcategory and hence forming an invalid link
    if (query?.trim()?.toLowerCase() == "gift cards" || query?.trim()?.toLowerCase() == "olivela") {
      window.location.assign(`/products/gift-card`);
    } else if (links == "vendor") {
      let urls = await generateSlug(query)
      window.location.assign(`/designer/${urls}`);
    }else if (links == "category") {
      // let slugs = await generateSlug(query)
      let urls = await buildLink(query)
     
      window.location.assign(urls);


    } else if (links == "subcategory") {
      let urls = await buildLink(url.split('>').shift().trim(), url.split('>').pop().trim())


      window.location.assign(urls);
    } else if (links == "nestedcategory") {

      let urls = await buildLink(url.split('>').shift().trim(),
        url.slice(url.indexOf('>') + 1, url.lastIndexOf('>'),).trim(),
        url.split('>').pop().trim())


      window.location.assign(urls);


    }
    else {
      // let urls = await generateSlug(query)
      window.location.assign(`/search?query=${query.toLowerCase()}`);
    }

  };

  function stripTags(original) {
    return original.replace(/(<([^>]+)>)/gi, "");
  }
  if (autocompleteState)
    return (
      <>
        <div
          className={`aa-Autocomplete ${styles.autocomplete_wrapper}`}
          {...autocomplete.getRootProps({})}
        >
          <form
            className="aa-Form"
            {...autocomplete.getFormProps({ inputElement: inputRef.current })}
          >
            {/* hide search icon in search result for PWA */}
            {!isPWA && <div className={`search_icon`}>
              <Srcset
                svgFile={true}
                requirePath={true}
                height="20"
                width="20"
                alt="Search"
                src={"images/Icons/Search.svg"}
              />
            </div>}
            {!inputRef?.current?.value.length && isPWA && querys==="" && <span className={`x-small ${isPWA && styles.pwa_search_placeholder}`}>Search</span>}
            <input
              ref={inputRef}
              placeholder={ !inputRef?.current?.value.length && "Search"}
              className={`aa-Input ${styles.input_search} large light auto-searchBar ${isPWA && styles.pwa_search}`}
              {...autocomplete.getInputProps({})}
              onKeyPress={(ev) => {
                if (ev.key === "Enter" && ev.target.value) {
                  redirectSearch(stripTags(ev.target.value));
                }
              }}
            />
            {inputRef?.current?.value.length > 0 && (
              <div
                tabIndex={0}
                className={`${styles.clear_seach} small-md small-sm xx-small-xs medium-xs`}
                onClick={handleClearInput}
              >
                Clear
              </div>
            )}
          </form>
          <div className="aa-Panel" {...autocomplete.getPanelProps({})}>
            {/* SEARCH COMPONENT */}
            {autocompleteState.collections?.map((collection, index) => {
              const { source, items } = collection;
              if (items) {
                
                uniqueChars = []
               
                items.forEach((item) => {
                  
                  if (
                    item.__autocomplete_indexName ==
                    process.env.SHOPIFY_QUERY_SUGGESTIONS_INDEX
                  ) {
                    shopifySuggetions.push(item);
                    if (item._highlightResult.query.matchLevel == "full") {
                      suggetionQuerys.push({ name: item._highlightResult.query.value.toLowerCase(), link: "query" });
                    }
                  }
                  if (
                    item.__autocomplete_indexName == process.env.SHOPIFY_PRIMARY_INDEX
                  ) {
                    categoryArr = []
                    try{
                      if (item.named_tags['categories.lvl0']) {
                        if (typeof (item.named_tags['categories.lvl0']) == "string") {
                          var strRegExp = new RegExp(autocompleteState.query, 'g');
                          categoryArr.push({ name: item.named_tags['categories.lvl0'].replace(strRegExp, '<span class=\"search-highlight\">' + autocompleteState.query + '</span>'), link: "category", url: item.named_tags['categories.lvl0'] })
                        } else {
                            var strRegExp = new RegExp(autocompleteState.query, 'g');
                            item.named_tags['categories.lvl0'].map((data) => {
                            categoryArr.push({ name: data.replace(strRegExp, '<span class=\"search-highlight\">' + autocompleteState.query + '</span>'), link: "category", url: data })
                          })
                        }
                        // categoryArr.push({ name: item.named_tags['categories.lvl0'], link: "category" })
                      }
                    
                      if (item.named_tags['categories.lvl1']) {
                        if (typeof (item.named_tags['categories.lvl1']) == "string") {
                            var strRegExp = new RegExp(autocompleteState.query, 'g');
                            categoryArr.push({ name: ` ${item.named_tags['categories.lvl1'].split(">").pop().trim().replace(strRegExp, '<span class=\"search-highlight\">' + autocompleteState.query + '</span>')}`, link: "subcategory", url: item.named_tags['categories.lvl1'] })
                        } else {
                          item.named_tags['categories.lvl1'].forEach((data) => {
                              var strRegExp = new RegExp(autocompleteState.query, 'g');
                              categoryArr.push({ name: ` ${data.split(">").pop().trim().replace(strRegExp, '<span class=\"search-highlight\">' + autocompleteState.query + '</span>')}`, link: "subcategory", url: data })
                          })
                        }
  
                      }
                      if (item.named_tags['categories.lvl2']) {
  
                        if (typeof (item.named_tags['categories.lvl2']) == "string") {
                          categoryArr.push({ name: item.named_tags['categories.lvl2'].split('>').pop(), link: "nestedcategory", url: item.named_tags['categories.lvl2'] })
  
                        } else {
                          item.named_tags['categories.lvl2'].forEach((data) => {
                            categoryArr.push({ name: data.split('>').pop(), link: "nestedcategory", url: data })
  
                          })
                        }
  
                      }
                      if (item._highlightResult.vendor.matchLevel == "full") {
                        arr.push({ name: item._highlightResult.vendor.value.toLowerCase(), link: "vendor" });
                      }
                      else {
                          var strRegExp = new RegExp(autocompleteState.query, 'g');
                          arr.push({ name: item.vendor.toLowerCase().replace(strRegExp, '<span class=\"search-highlight\">' + autocompleteState.query + '</span>'), link: "vendor" });
                      }
                    }catch(err){
                      console.log(err,"Error in search suggestion");
                      
                    }
                  }
                  // uniqueChars = [...new Set(arr)];
                  // uniqueChars = [...new Map(arr.map((item, key) => [item[key],item])).values()]

                  var result = arr.filter(function (o1) {
                    return suggetionQuerys.some(function (o2) {
                      return o1.name === o2.name; // return the ones with equal id
                    });
                  });
              
                  // uniqueChars.push(...arr)
                  const key = 'name';
                  
                  const arrayUniqueByKey = [...new Map(categoryArr.map(item =>
                    [item[key], item])).values()];
                  uniqueChars = Object.values(result.reduce((acc, cur) => Object.assign(acc, { [cur.name]: cur }), {}))


                  if (result.length == 0) {
                    var uniqueValue = [...arr, ...arrayUniqueByKey]
                    const uniques = [...new Map(uniqueValue.map((item, key) => [item['name'], item])).values()]
                    uniqueChars.push(...uniques);
                  } else {
                    // const uniques = [...arrayUniqueByKey]
                    // const uniqueArr = [...new Map(uniques.map((item, key) => [item['name'], item])).values()]
                    
                    uniqueChars.push(...arrayUniqueByKey)
                  }
                 

                  
                  // uniqueChars.push([...new Map(uniqueChars.map((item, key) => [item['name'], item])).values()])

                });
                return autocompleteState.query &&
                  uniqueChars?.length === 0 &&
                  arr.length === 0 ? (
                  /* No Result COMPONENT */
                  <Popular
                    query={autocompleteState.query}
                    autocomplete={autocomplete}
                  />
                ) : (
                  <>
                    <div className={`${styles.suggestion_title} x-large-xs large-sm large-md light`}>
                      <span>
                        {autocompleteState.query
                          ? "Suggestions"
                          : "Most popular searches"}
                      </span>
                      {autocompleteState.query && items.length > 10 && (
                        <a
                          tabIndex={-1}
                          href={`/search?query=${autocompleteState.query.toLowerCase()}`}
                          passHref
                          onClick={(e) => {
                            if(isPWA) {
                              dispatch(showPwaLoader(true))
                            }
                        }}
                        >
                          <div tabIndex={0} className={`${styles.view_all}`}>
                            <span className={`${styles.view_title} x-small`}>
                              View all
                            </span>
                            <div className={`${styles.arrow}`}>
                              <Srcset
                                svgFile={true}
                                requirePath={true}
                                alt="right-arrow"
                                height="10"
                                width="12"
                                src={
                                  "images/Icons/Arrow/Right/Large_dark.svg"
                                }
                              />
                            </div>
                          </div>
                        </a>
                      )}
                    </div>
                    {items.length ? (
                      <>
                        {arr.length > 0 && (
                          <div className={`${styles.suggestion_container}`}>
                            <div
                              className={`swiper-button ${styles.swiper_prev} ${items.length}`}
                              ref={prevRef}
                            >
                              <Srcset
                                tabIndex={0}
                                svgFile={true}
                                requirePath={true}
                                alt="right-arrow"
                                width="12"
                                height="10"
                                src={
                                  "images/Icons/Arrow/Right/Large_dark.svg"
                                }
                              />
                            </div>
                            <Swiper
                              slidesPerView={"auto"}
                              speed={500}
                              slidesPerGroup={3}
                              spaceBetween={20}
                              loop={false}
                              draggable={true}
                              className={`${styles.aa_suggestions_wrapper} ${styles.swiper}`}
                              navigation={{
                                prevEl: prevRef?.current,
                                nextEl: nextRef?.current,
                              }}
                              modules={[Navigation, A11y]}
                              onSwiper={setSwiper}
                            >
                              {autocompleteState.query &&
                                uniqueChars?.length > 0 &&
                                uniqueChars?.map((item) => (
                                  <SwiperSlide
                                    key={item.name}
                                    className={`${styles.swiper_slide}`}
                                  >
                                    <div
                                      tabIndex={0}
                                      className={`${styles.aa_suggestions_highlight} x-small`}
                                      {...autocomplete.getItemProps({
                                        item,
                                        source,
                                      })}
                                      onClick={() => {
                                        ({
                                          ...autocomplete.setIsOpen(true),
                                          ...autocomplete.setQuery(
                                            stripTags(item?.name.toLowerCase())
                                          ),
                                          ...autocomplete.refresh(),
                                          ...autocomplete.setIsOpen(true),
                                        },
                                          setQuerys(stripTags(item.name)),
                                          redirectSearch(stripTags(item.name), item.link, item.url));
                                      }}
                                    >

                                      <div
                                        className={`${styles.aa_suggestions_text}`}
                                        dangerouslySetInnerHTML={{
                                          __html: item?.name,
                                        }}
                                      ></div>
                                    </div>
                                  </SwiperSlide>
                                ))}
                              {!autocompleteState.query &&
                                items.map((item) =>
                                  item.__autocomplete_indexName ==
                                  process.env.SHOPIFY_QUERY_SUGGESTIONS_INDEX ? (
                                      
                                   
                                    <SwiperSlide
                                      key={item.objectID}
                                      className={`${styles.swiper_slide}`}
                                    >
                                      <div
                                        tabIndex={0}
                                        className={`${styles.aa_suggestions_highlight} x-small medium`}
                                        {...autocomplete.getItemProps({
                                          item,
                                          source,
                                        })}
                                        onClick={() => {
                                          ({
                                            ...autocomplete.setQuery(
                                              item.query
                                            ),
                                            ...autocomplete.refresh(),
                                          },
                                            setQuerys(item.query),
                                            redirectSearch(item.query));
                                        }}
                                      >
                                        {item._highlightResult.query
                                          .matchLevel == "none" && (
                                            <div>{item.query}</div>
                                          )}
                                        {item._highlightResult.query
                                          .matchLevel == "full" && (
                                           
                                            <div
                                              className={`${styles.aa_suggestions_text}`}
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  item._highlightResult.query
                                                    .value,
                                              }}
                                            ></div>
                                          )}
                                      </div>
                                    </SwiperSlide>
                                  ) : (
                                    ""
                                  )
                                )}
                            </Swiper>
                            <div
                              className={`swiper-button ${styles.swiper_next} ${items.length}`}
                              ref={nextRef}
                            >
                              <Srcset
                                tabIndex={0}
                                svgFile={true}
                                requirePath={true}
                                alt="right-arrow"
                                height="12"
                                width="12"
                                src={
                                  "images/Icons/Arrow/Right/Large_dark.svg"
                                }
                              />
                            </div>
                          </div>
                        )}
                        {arr?.length == 0 && (
                          <div className={`${styles.suggestion_container}`}>
                            <div
                              className={`swiper-button ${styles.swiper_prev}`}
                              ref={prevRef}
                            >
                              <Srcset
                                tabIndex={0}
                                svgFile={true}
                                requirePath={true}
                                alt="right-arrow"
                                width="12"
                                height="10"
                                src={
                                  "images/Icons/Arrow/Right/Large_dark.svg"
                                }
                              />
                            </div>
                            <Swiper
                              slidesPerView={"auto"}
                              speed={500}
                              spaceBetween={20}
                              slidesPerGroup={3}
                              loop={false}
                              draggable={true}
                              className={`${styles.aa_suggestions_wrapper} ${styles.swiper}`}
                              navigation={{
                                prevEl: prevRef?.current,
                                nextEl: nextRef?.current,
                              }}
                              modules={[Navigation, A11y]}
                              onSwiper={setSwiper}
                            >
                              {autocompleteState.query &&
                                uniqueChars?.length > 0 &&
                                uniqueChars?.map((item) => (

                                  <>
                                    {
                                      <SwiperSlide
                                        key={item.name}
                                        className={`${styles.swiper_slide}`}
                                      >
                                        <div
                                          tabIndex={0}
                                          className={`${styles.aa_suggestions_highlight} x-small medium`}
                                          {...autocomplete.getItemProps({
                                            item,
                                            source,
                                          })}
                                          onClick={() => {
                                            ({
                                              ...autocomplete.setIsOpen(true),
                                              ...autocomplete.setQuery(
                                                stripTags(item.name.toLowerCase())
                                              ),
                                              ...autocomplete.refresh(),
                                              ...autocomplete.setIsOpen(true),
                                            },
                                              setQuerys(stripTags(item.name)),
                                              redirectSearch(stripTags(item.name), item.link, item.url));
                                          }}
                                        >
                                          <div
                                            className={`${styles.aa_suggestions_text}`}
                                            dangerouslySetInnerHTML={{
                                              __html: item.name.toString().replace(" & ", " ").replace(" & ", " "),
                                            }}
                                          ></div>
                                        </div>
                                      </SwiperSlide>
                                    }
                                  </>
                                ))}
                              {!autocompleteState.query &&
                                items.map((item) => (
                 

                                  <>
                                    {item.__autocomplete_indexName ==
                                      process.env.SHOPIFY_QUERY_SUGGESTIONS_INDEX ? (
                                     
                                      <SwiperSlide
                                        key={item.objectID}
                                        className={`${styles.swiper_slide}`}
                                      >
                                        <div
                                          tabIndex={0}
                                          className={`${styles.aa_suggestions_highlight} x-small medium`}
                                          {...autocomplete.getItemProps({
                                            item,
                                            source,
                                          })}
                                          onClick={() => {
                                            ({
                                              ...autocomplete.setQuery(
                                                item.query
                                              ),
                                              ...autocomplete.refresh(),
                                            },
                                              setQuerys(item.query),
                                              redirectSearch(item.query));
                                          }}
                                        >
                                          {item._highlightResult.query
                                            .matchLevel == "none" && (
                                              <div>{item.query}</div>
                                            )}
                                          {item._highlightResult.query
                                            .matchLevel == "full" && (
                                              <div
                                                className={`${styles.aa_suggestions_text}`}
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    item._highlightResult.query
                                                      .value,
                                                }}
                                              ></div>
                                            )}
                                        </div>
                                      </SwiperSlide>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                ))}
                            </Swiper>
                            <div
                              className={`swiper-button ${styles.swiper_next}`}
                              ref={nextRef}
                            >
                              <Srcset
                                tabIndex={0}
                                svgFile={true}
                                requirePath={true}
                                alt="right-arrow"
                                height="12"
                                width="12"
                                src={
                                  "images/Icons/Arrow/Right/Large_dark.svg"
                                }
                              />
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      <Popular
                        query={autocompleteState.query}
                        autocomplete={autocomplete}
                      />
                    )}
                    <div key={`source-${index}`} className="ais-Hits">
                      {items.length > 0 && autocompleteState.query && (
                        <ul
                          className="ais-Hits-list"
                          {...autocomplete.getListProps()}
                        >
                          {items.map((item) => {
                            {
                              if (
                                item.__autocomplete_indexName ==
                                process.env.SHOPIFY_PRIMARY_INDEX
                              ) {
                                return (
                                  <>
                                    <li
                                      key={"item.handel"}
                                      className="ais-Hits-item"
                                    >
                                      <ProductItemTile
                                        hit={item}
                                        autocomplete={autocomplete}
                                        searchComp={true}
                                      />
                                    </li>
                                  </>
                                );
                              }
                            }
                          })}
                        </ul>
                      )}
                      {!autocompleteState.query && items.length > 0 && (
                        <ul
                          className="ais-Hits-list"
                          {...autocomplete.getListProps()}
                        >
                          {items.map((item) => {
                            {
                              if (
                                item.__autocomplete_indexName ==
                                process.env.SHOPIFY_RECENTLY_ORDERED_INDEX
                              ) {
                                return (
                                  <>
                                    <li
                                      key={"item.handel"}
                                      className="ais-Hits-item"
                                    >
                                      <ProductItemTile hit={item} searchComp={true} />
                                    </li>
                                  </>
                                );
                              }
                            }
                          })}
                        </ul>
                      )}
                    </div>
                    {autocompleteState.query && items.length > 10 && (
                      <Link
                        href={`/search?query=${autocompleteState.query}`}
                        onClick={(e) => {
                          if(isPWA) {
                            dispatch(showPwaLoader(true))
                          }
                      }}
                      >
                        <div
                          className={`${styles.view_title_tile}`}
                          onClick={handleClickSearchClose}
                          tabIndex={0}
                        >
                          <span className={`${styles.view_header} normal-md x-small-sm x-small-xs`}>
                            View all
                          </span>
                          <div className={`${styles.view_arrow}`}>
                            <Srcset
                              svgFile={true}
                              requirePath={true}
                              alt="right-arrow"
                              height="10"
                              width="12"
                              src={
                                "images/Icons/Arrow/Right/Large_dark.svg"
                              }
                            />
                          </div>
                        </div>
                      </Link>
                    )}
                  </>
                );
              }
            })}
          </div>
        </div>
      </>
    );
};

export default ProductItem;
